import { Label } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { APPLICATION_LIST_HEADERS, RWBCIS_APPLICATION_LIST_HEADERS } from "../DashboardHelper";

const ApplicationDetails = (props: any) => {
    const {
        storeApplicationSearchData,
    } = useSelector((state: any) => state.grievances);
    let tableData = storeApplicationSearchData?.data ?? []

    return (
        <>
            <Label>
                <img 
                    src={require('../../../assets/img/Back.svg').default} 
                    style={{marginRight:'15px', cursor: 'pointer'}}
                    onClick={() => {
                        props?.setSearchSection(!props?.searchSection);
                        props?.setShowApplicationTable(false);
                    }}
                />
                {props?.getValues('searchApplication') && <span>Application Number: {props?.getValues('searchApplication')}</span>}
                {props?.getValues('searchPMFBYPolicy') && <span>Policy Number: {props?.getValues('searchPMFBYPolicy')}</span>}
                {props?.getValues('searchRWBCISApplication') && <span>Application Number: {props?.getValues('searchRWBCISApplication')}</span>}
                {props?.getValues('searchRWBCISPolicy') && <span>Policy Number: {props?.getValues('searchRWBCISPolicy')}</span>}
            </Label>
            <div className="table-container">
                <TableComponent 
                    data={tableData}
                    columnHeaders={props?.getValues('searchRWBCISApplication') || props?.getValues('searchRWBCISPolicy') ? RWBCIS_APPLICATION_LIST_HEADERS : APPLICATION_LIST_HEADERS}
                    onAction={props?.onTableAction}
                    responsive={false}
                />
            </div>
        </>
    );
}

export default ApplicationDetails;